import {
  ClientRepresentationStatusEnum,
  ClientRepresentationTypeEnum,
} from '@sr-sdks/api-sdk-axios';
import { STATUS_BADGE_PRESETS } from '../Badges/appBadgeConstants';
import { getDateFormat } from '../DateFormatter';

/** date-fns throws on unparseable input, so bad dates collapse to undefined. */
export const formatOptionalDate = (value?: string) => {
  if (!value) return undefined;

  try {
    return getDateFormat(value, 'short') || undefined;
  } catch {
    return undefined;
  }
};

export const formatRepresentationPeriod = (
  startDate?: string,
  endDate?: string,
) => {
  const start = formatOptionalDate(startDate);
  const end = formatOptionalDate(endDate);

  if (start && end) return `${start} – ${end}`;
  if (start) return `From ${start}`;
  if (end) return `Until ${end}`;

  return undefined;
};

/** The agent's own reference, which the design calls "Client ID" — not `shortId`. */
export const formatClientIdLabel = (clientReferenceId?: string) =>
  clientReferenceId ? `Client ID: ${clientReferenceId}` : undefined;

/** Label comes from the badge presets so card and pill wording stay in step. */
export const formatRepresentationStatus = (
  status?: ClientRepresentationStatusEnum,
): string | undefined => {
  if (!status) return undefined;

  const label = STATUS_BADGE_PRESETS.ClientRepresentation[status]?.children;

  return typeof label === 'string' ? label : undefined;
};

const REPRESENTATION_TYPE_LABELS: Partial<
  Record<ClientRepresentationTypeEnum, string>
> = {
  [ClientRepresentationTypeEnum.Agency]: 'Agency',
  [ClientRepresentationTypeEnum.Assignment]: 'Assignment',
};

/**
 * Only agents that record rights assignment (currently two members) set a
 * type, so `unspecified` and missing both collapse to undefined and the field
 * stays hidden for everyone else.
 */
export const formatRepresentationType = (
  type?: ClientRepresentationTypeEnum,
): string | undefined => (type ? REPRESENTATION_TYPE_LABELS[type] : undefined);
